import { IPromoInfoSchema } from '../../../../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';

export function getImageUrl(promo: IPromoInfoSchema): string {
  if (promo.isFromBank) {
    return promo.bank?.secondSquareImageUrl || '';
  }

  return promo.authorLogoUrl || '';
}
